import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileStepperComponent } from './mobile-stepper.component';



@NgModule({
    declarations: [MobileStepperComponent],
    imports: [
        CommonModule
    ],
    exports: [MobileStepperComponent]
})
export class MobileStepperModule { }
